import styled from 'styled-components';

export const ExportUserTimesheetModalStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 4px;
  min-width: 420px;

  .row {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .helper {
    font-size: 12px;
    color: #6b6b80;
  }

  .error {
    font-size: 12px;
    color: #d32f2f;
  }
`;
